import { type LoaderFunctionArgs } from 'react-router'
import { Prisma } from '#app/generated/prisma/client.js'
import { prisma } from '#app/utils/db.server.js'

export async function loader({ request }: LoaderFunctionArgs) {
	const url = new URL(request.url)
	const code = url.searchParams.get('code')
	const state = url.searchParams.get('state') // writeKey

	if (code && state) {
		try {
			await prisma.betterAuthKeyPair.update({
				where: { writeKey: state },
				data: { code },
			})
		} catch (error) {
			if (
				error instanceof Prisma.PrismaClientKnownRequestError &&
				error.code === 'P2025'
			) {
				// Record already consumed by plugin polling — flow succeeded
			} else {
				throw error
			}
		}
	}
	return null
}

export default function FramerPaired() {
	return (
		<div className="flex h-screen flex-col items-center justify-center">
			<h1 className="text-3xl font-bold">
				Iconited Successfully Paired with Framer
			</h1>
			<p className="text-lg">
				You can now close this window and return to Framer.
			</p>
		</div>
	)
}
